/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Max_Words_Per_MinuteInputs */

const en_max_words_per_minute = /** @type {(inputs: Max_Words_Per_MinuteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Max Words Per Minute (WPM)`)
};

const fr_max_words_per_minute = /** @type {(inputs: Max_Words_Per_MinuteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Max mots par minute (MPM)`)
};

const de_max_words_per_minute = /** @type {(inputs: Max_Words_Per_MinuteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Maximale Wörter pro Minute (WPM)`)
};

const it_max_words_per_minute = /** @type {(inputs: Max_Words_Per_MinuteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Numero massimo di parole al minuto (WPM)`)
};

const ru_max_words_per_minute = /** @type {(inputs: Max_Words_Per_MinuteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Максимальная скорость печати (слов в минуту)`)
};

const es_max_words_per_minute = /** @type {(inputs: Max_Words_Per_MinuteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Máximo de palabras por minuto (WPM)`)
};

const zh_cn2_max_words_per_minute = /** @type {(inputs: Max_Words_Per_MinuteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`每分钟最大字数 (WPM)`)
};

const ja_max_words_per_minute = /** @type {(inputs: Max_Words_Per_MinuteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1分あたりの最大単語数（WPM）`)
};

const hi_max_words_per_minute = /** @type {(inputs: Max_Words_Per_MinuteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`अधिकतम शब्द प्रति मिनट (WPM)`)
};

const pt_pt2_max_words_per_minute = /** @type {(inputs: Max_Words_Per_MinuteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Máximo de palavras por minuto (PPM)`)
};

/**
* | output |
* | --- |
* | "Max Words Per Minute (WPM)" |
*
* @param {Max_Words_Per_MinuteInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const max_words_per_minute = /** @type {((inputs?: Max_Words_Per_MinuteInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Max_Words_Per_MinuteInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_max_words_per_minute(inputs)
	if (locale === "de") return de_max_words_per_minute(inputs)
	if (locale === "it") return it_max_words_per_minute(inputs)
	if (locale === "ru") return ru_max_words_per_minute(inputs)
	if (locale === "es") return es_max_words_per_minute(inputs)
	if (locale === "zh-CN") return zh_cn2_max_words_per_minute(inputs)
	if (locale === "ja") return ja_max_words_per_minute(inputs)
	if (locale === "hi") return hi_max_words_per_minute(inputs)
	if (locale === "pt-PT") return pt_pt2_max_words_per_minute(inputs)
	return en_max_words_per_minute(inputs)
});